// extracted by mini-css-extract-plugin
export default {"root":"UploadButtons__root--2JqBh","uploadItem":"UploadButtons__uploadItem--XKTub","text":"UploadButtons__text--3hIwz"};